import React, { useEffect, useImperativeHandle, forwardRef, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';
import '@nt/dds-style/core/panel.css';
var PortalPanel = forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    height = props.height,
    id = props.id,
    isOpen = props.isOpen,
    width = props.width,
    top = props.top,
    left = props.left,
    noPadding = props.noPadding,
    role = props.role,
    portalContainerId = props.portalContainerId,
    sibling = props.sibling;
  var target = useRef(document.getElementById(portalContainerId));
  var panelRef = useRef(null);
  useImperativeHandle(ref, function () {
    return panelRef.current;
  });
  var portalPanelClasses = cx({
    panel: true,
    'zindex-1': true,
    'position-absolute': true,
    'opacity-100p': isOpen,
    'opacity-0': !isOpen,
    'display-block': isOpen,
    'display-none': !isOpen,
    'overflowy-auto': true,
    'overflowx-hidden': true,
    'padding-md': !noPadding,
    'padding-0': noPadding
  }, className);
  useEffect(function () {
    if (panelRef.current) {
      panelRef.current.style.height = typeof height === 'string' ? height : "".concat(height, "px");
      panelRef.current.style.width = "".concat(width, "px");
      panelRef.current.style.top = "".concat(top, "px");
      panelRef.current.style.left = "".concat(left, "px");
    }
  }, [isOpen, height, width, top, left, ref]);
  return ReactDOM.createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: portalPanelClasses,
    id: id,
    role: role,
    ref: panelRef,
    "aria-hidden": !isOpen
  }, children), sibling), portalContainerId ? target.current : document.body);
});
PortalPanel.propTypes = {
  children: PropTypes.node,
  /** Sibling component to display within the same portal */
  sibling: PropTypes.node,
  className: PropTypes.string,
  /** unique ID of the panel */
  id: PropTypes.string,
  /** Display the panel when set to true */
  isOpen: PropTypes.bool,
  /** Width of panel */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Height of panel */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Top coordinate from absolute position of the parenteElementId */
  top: PropTypes.number,
  /** Left coordinate from absolute position of the parenteElementId */
  left: PropTypes.number,
  /** remove padding */
  noPadding: PropTypes.bool,
  /** Role of the panel (e.g. tooltip, dialog, alertdialog) */
  role: PropTypes.string,
  /** Id of the parent container for portal(if not provided the portal will be attached to document.body by default)  */
  portalContainerId: PropTypes.string
};
PortalPanel.displayName = 'PortalPanel';
export default PortalPanel;